import OnlinePaymentWrapper from './OnlinePaymentWrapper';
export default OnlinePaymentWrapper;
